export const DATA = 'DATA'
export const SNACKBAR = 'SNACKBAR'
export const REDIRECT = 'REDIRECT'
export const OPEN_MENU = 'OPEN_MENU'
export const LOADING_PAGE = 'LOADING_PAGE'
export const LOADING_BACKDROP = 'LOADING_BACKDROP'
export const CATEGORY_DETAILS = 'CATEGORY_DETAILS'

